<template>
  <div class="container-custom">
    <!-- BreadScrumbs -->
    <BreadScrumbs
      :links="[{ name: 'EDM Send List', to: { path: '/edm-send-list' } }]"
    ></BreadScrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>EDM Send List</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="createHandler">
        <v-icon class="pr-2 white--text">add</v-icon>
        <span>新增EDM</span>
      </button>
    </div>
    <!--  -->
    <EDMTable class="mb-5"></EDMTable>
  </div>
</template>

<script>
import BreadScrumbs from '@/components/Breadscrumbs.vue';
import EDMTable from '@/views/K__eNewsletterEDMlist/c/EDMTable.vue';

export default {
  components: {
    BreadScrumbs,
    EDMTable,
  },
  methods: {
    createHandler() {
      this.$router.push('/edm-send-list/create');
    },
  },
};
</script>

<style></style>
